import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getOverlayPrefs, subscribeOverlayPrefs } from '../common/overlayPrefs';
import './liveStyle.css';

/**
 * CameraInfoOverlay — per-tile OSD (redesign #86bb5dx62).
 *   timestamp → top-left  (each tile's own stream time; the lag/desync signal)
 *   name      → bottom-left
 * No transport (WS/JPG) badge at rest — a degraded-transport indicator surfaces
 * later (Mock B). Hidden entirely when the shared "Name & Timestamp" toggle
 * (overlayPrefs.info; Setup > Display) is off.
 */
const CameraInfoOverlay = ({ camName, timestamp, conf, fSingle }) => {
    const [overlayHidden, setOverlayHidden] = useState(() => !getOverlayPrefs().info);

    useEffect(() => subscribeOverlayPrefs((p) => setOverlayHidden(!p.info)), []);

    if (overlayHidden) return null;

    const classes = ['live-overlay'];
    if (fSingle) {
        classes.push('live-overlay--single');
    } else if (conf) {
        classes.push(`live-overlay--${conf}`);
    }

    return (
        <div className={classes.join(' ')}>
            { timestamp && <span className="live-overlay__time">{timestamp}</span> }
            { camName && <p className="live-overlay__text">{camName}</p> }
        </div>
    );
};

const mapStateToProps = state => ({
    conf: state.config.conf,
    fSingle: state.video.fSingle
});

export default connect(mapStateToProps)(CameraInfoOverlay);
